<template>
  <!-- 内容 -->
  <div class="sharePage">
    <!--    <a v-if="showShare" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.e23.shun_shi_zhen" class="sharebarimg"><img-->
    <!--      src="../../images/shareBar-top.png" alt=""></a>-->
    <a
      href="https://appgallery.huawei.com/app/C102675979"
      class="sharebarimg"
      ><img src="../../images/shareBar-top.png" alt=""
    /></a>
    <div class="authorDetial flexBox">
      <div class="authorImg fullImg">
        <Avatar :user="user" size="def" />
      </div>
      <div class="authorMsg">
        <p class="authorName">{{ user.name }}</p>
        <p class="authorLabel">
          <span class="datetimes">{{
            feed.created_at | time2tips | t("article.posted_at")
          }}</span>
          <span class="newsLabel-info news-lookNumber">
            <span class="news-lookNumberIcon fullImg">
              <img src="../../images/icon_look@2x.png" alt />
            </span>
            {{ feed.feed_view_count }}
          </span>
        </p>
      </div>
    </div>
    <main class="m-flex-shrink1 m-flex-grow1 m-art m-main">
      <div class="m-art-body">
        <h2 v-if="title">{{ title }}</h2>
        <video
          v-if="video && video.resource"
          :poster="cover_file"
          x5-playsinline=""
          playsinline=""
          webkit-playsinline=""
          preload="auto"
          class="feed-detail-video"
          controls
          autoplay
        >
          <source :src="video_file" type="video/mp4" />
        </video>
        <div class="imgParentView">
          <div :class="'pic-' + images.length" v-if="images.length < 3">
            <div v-for="img in images" :key="img.id">
              <img
                preview="1"
                v-if="feed.images"
                :src="img.url"
                @click="onFileClick(img)"
              />
            </div>
          </div>
          <div class="pic-3" v-if="images.length === 3">
            <div><img :src="images[0].url" preview="1" /></div>
            <div>
              <div><img :src="images[1].url" preview="1" /></div>
              <div><img :src="images[2].url" preview="1" /></div>
            </div>
          </div>
          <div class="pic-4" v-if="images.length === 4">
            <img
              v-for="img in images"
              v-if="feed.images"
              :key="img.id"
              :src="img.url"
              preview="1"
            />
          </div>
          <div class="pic-5" v-if="images.length === 5">
            <div>
              <img :src="images[0].url" preview="1" />
              <div>
                <img :src="images[1].url" preview="1" />
                <img :src="images[2].url" preview="1" />
              </div>
            </div>
            <div>
              <img :src="images[3].url" preview="1" />
              <img :src="images[4].url" preview="1" />
            </div>
          </div>
          <div class="pic-5 pic-6" v-if="images.length === 6">
            <div>
              <img :src="images[0].url" preview="1" />
              <div>
                <img :src="images[1].url" preview="1" />
                <img :src="images[2].url" preview="1" />
              </div>
            </div>
            <div>
              <img :src="images[3].url" preview="1" />
              <img :src="images[4].url" preview="1" />
              <img :src="images[5].url" preview="1" />
            </div>
          </div>
          <div class="pic-7" v-if="images.length === 7">
            <div>
              <img :src="images[0].url" preview="1" />
              <img :src="images[1].url" preview="1" />
            </div>
            <div>
              <img :src="images[2].url" preview="1" />
              <img :src="images[3].url" preview="1" />
            </div>
            <div>
              <img :src="images[4].url" preview="1" />
              <img :src="images[5].url" preview="1" />
              <img :src="images[6].url" preview="1" />
            </div>
          </div>
          <div class="pic-8" v-if="images.length === 8">
            <div>
              <img :src="images[0].url" preview="1" />
              <img :src="images[1].url" preview="1" />
            </div>
            <div>
              <img :src="images[2].url" preview="1" />
              <img :src="images[3].url" preview="1" />
              <img :src="images[4].url" preview="1" />
              <img :src="images[5].url" preview="1" />
              <img :src="images[6].url" preview="1" />
              <img :src="images[7].url" preview="1" />
            </div>
          </div>
          <div class="pic-9" v-if="images.length === 9">
            <img
              v-for="img in images"
              v-if="feed.images"
              :key="img.id"
              preview="1"
              :src="img.url"
            />
          </div>
          <div class="pic-9" v-if="images.length > 9">
            <div
              class="imgParet"
              v-for="(img, idx) in images"
              v-if="feed.images"
              v-show="idx < 9"
              :key="img.id"
            >
              <img preview="1" :src="img.url" />
              <span v-if="idx === 8" class="imgCout"
                >+{{ images.length - idx - 1 }}
              </span>
            </div>
          </div>
        </div>
        <p class="m-text-box m-text-pre" v-html="formatBody(feedContent)" />
        <ul v-if="topics.length" class="topics">
          <li
            v-for="topic in topics"
            :key="topic.id"
            class="topic-item"
            v-text="topic.name"
          />
        </ul>
      </div>
    </main>
    <p class="fullScreenBar" />
    <ArticleComments
      ref="comments"
      type="feed"
      :article="feedId"
      :total.sync="commentCount"
      :fetching="fetchComing"
      @reply="replyComment"
    />
    <a
      href="https://appgallery.huawei.com/app/C102675979"
      class="sharebarimg fixedbar"
      ><img src="../../images/shareBar-bottom.png" alt=""
    /></a>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { escapeHTML } from "@/filters";
import wechatShare from "@/util/wechatShare.js";
import * as userApi from "@/api/user.js";
import * as api from "@/api/feeds.js";
import ArticleComments from "@/page/article/components/ArticleComments";

export default {
  name: "FeedDetail",
  components: {
    ArticleComments,
  },
  data() {
    return {
      feed: {},
      oldId: NaN,
      loading: true,
      fetching: false,

      rewardCount: 0,
      rewardAmount: 0,
      rewardList: [],

      fetchComing: false,
      noMoreCom: false,
      maxComId: 0,
      user: {},
    };
  },
  computed: {
    showShare() {
      return this.$route.query.is_share === "1";
    },
    ...mapState(["CURRENTUSER"]),
    allowReward() {
      return this.$store.state.CONFIG.site.reward.status;
    },
    reward() {
      return {
        count: this.rewardCount,
        amount: this.rewardAmount,
        list: this.rewardList,
      };
    },
    feedId() {
      return Number(this.$route.params.feedId);
    },
    video() {
      return this.feed.video;
    },
    video_file() {
      return this.video && this.video.resource
        ? this.video.resource.url
        : false;
    },
    title() {
      return this.feed.title;
    },
    cover_file() {
      return this.video && this.video.cover ? this.video.cover.url : false;
    },
    isMine() {
      return this.feed.user_id === this.CURRENTUSER.id;
    },
    topics() {
      return this.feed.topics || [];
    },
    likes: {
      get() {
        return this.feed.likes || [];
      },
      set(val) {
        this.feed.likes = val;
      },
    },
    liked: {
      get() {
        return !!this.feed.has_like;
      },
      set(val) {
        this.feed.has_like = val;
      },
    },
    likeCount: {
      get() {
        return this.feed.like_count || 0;
      },
      set(val) {
        this.feed.like_count = ~~val;
      },
    },
    commentCount: {
      get() {
        return this.feed.feed_comment_count || 0;
      },
      set(val) {
        this.feed.feed_comment_count += val;
      },
    },
    images() {
      return this.feed.images || [];
    },
    time() {
      return this.feed.created_at || "";
    },
    feedContent() {
      return this.feed.feed_content || "";
    },
    isWechat() {
      return this.$store.state.BROWSER.isWechat;
    },
    has_collect: {
      get() {
        return this.feed.has_collect;
      },
      set(val) {
        this.feed.has_collect = val;
      },
    },
    relation: {
      get() {
        const relations = {
          unFollow: {
            text: this.$t("follow.name"),
            status: "unFollow",
            icon: `#icon-unFollow`,
          },
          follow: {
            text: this.$t("follow.already"),
            status: "follow",
            icon: `#icon-follow`,
          },
          eachFollow: {
            text: this.$t("follow.each"),
            status: "eachFollow",
            icon: `#icon-eachFollow`,
          },
        };
        const { follower, following } = this.user;
        const relation =
          follower && following
            ? "eachFollow"
            : follower
            ? "follow"
            : "unFollow";
        return relations[relation];
      },

      set(val) {
        this.user.follower = val;
      },
    },
  },
  beforeMount() {
    // if (this.isIosWechat) {
    //   this.reload(this.$router)
    // }
  },
  activated() {
    if (this.feedId) {
      this.feed = {};
      this.fetchFeed();
    }
  },
  deactivated() {
    this.loading = true;
    this.share = {
      title: "",
      desc: "",
      link: "",
    };
    this.config = {
      appid: "",
      timestamp: 0,
      noncestr: "",
      signature: "",
    };
  },
  methods: {
    formatBody(str) {
      // XSS filter
      str = escapeHTML(str);

      const reg =
        /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
      return str
        ? str.replace(
            reg,
            (link) =>
              `<a class="m-art-links" href="${link}" target="__blank">#${this.$t(
                "article.link_text"
              )}#</a>`
          )
        : "";
    },
    fetchFeed() {
      if (this.fetching) return;
      this.fetching = true;
      this.loading = false;
      const shareUrl =
        window.location.origin +
        process.env.BASE_URL.substr(0, process.env.BASE_URL.length - 1) +
        this.$route.fullPath;
      const signUrl =
        this.$store.state.BROWSER.OS === "IOS" ? window.initUrl : shareUrl;
      this.$http.get(`/feeds/${this.feedId}`).then(({ data = {} }) => {
        this.feed = data;
        this.fetching = false;
        // this.$refs.loadmore.afterRefresh();
        //this.fetchUserInfo()
        this.user = Object.assign({}, this.user, data.user);
        document.getElementsByTagName("title")[0].innerText = `舜时针`;
        this.fetchFeedComments();
        // this.fetchFeedRewards()
        this.fetchFeedLikers();
        this.isWechat &&
          wechatShare(signUrl, {
            title: `${data.shareTitle}`,
            desc: `${data.shareDesc}`,
            link: shareUrl,
            imgUrl: `${data.share_image}`,
          });
        this.$previewRefresh();
      });
    },
    getShareImg(datas) {
      const data = datas;
      let imgurl = "";
      if (data.images.length > 0) {
        imgurl = data.images[0].url;
      }
      if (data.video) {
        imgurl = data.video.cover.url;
      }
      if (data.images.length === 0 && !data.video) {
        imgurl = "http://ssz.e23.cn/app/72icon.png";
      }
      return imgurl;
    },
    fetchUserInfo() {
      userApi.getUserInfoById(this.feed.user_id, true).then((user) => {
        this.user = Object.assign({}, this.user, user);
      });
    },
    fetchFeedComments() {
      this.$refs.comments.fetch();
    },
    fetchFeedRewards(inc) {
      if (inc) {
        this.rewardCount += 1;
        this.rewardAmount += inc;
      } else {
        const { count = 0, amount = 0 } = this.feed.reward;
        this.rewardCount = Number(count);
        this.rewardAmount = Number(amount);
      }
      api.getFeedRewards(this.feedId, { limit: 10 }).then(({ data: list }) => {
        this.rewardList = list;
        this.$store.commit("SAVE_ARTICLE", {
          type: "rewarders",
          list,
        });
      });
    },
    async fetchFeedLikers() {
      const { data: list } = await api.getFeedLikers(this.feedId, { limit: 5 });
      this.feed.likes = list;
      this.$store.commit("SAVE_ARTICLE", {
        type: "likers",
        list,
      });
    },
    viewTopic(topicId) {
      this.$router.push({
        name: "TopicDetail",
        params: { topicId },
      });
    },
    afterReward(amount) {
      this.fetchRewards();
      this.rewardCount += 1;
      this.rewardAmount += amount;
    },
    likeFeed() {
      const method = this.liked ? "delete" : "post";
      const url = this.liked
        ? `/feeds/${this.feedId}/unlike`
        : `/feeds/${this.feedId}/like`;
      if (this.fetching) return;
      this.fetching = true;
      this.$http({
        method,
        url,
        validateStatus: (s) => s === 201 || s === 204,
      })
        .then(() => {
          if (method === "post") {
            this.liked = true;
            this.likeCount += 1;
            if (this.likes.length < 5) {
              this.likes.push({
                user: this.CURRENTUSER,
                id: new Date().getTime(),
                user_id: this.CURRENTUSER.id,
              });
            }
          } else {
            this.liked = false;
            this.likeCount -= 1;
            this.likes = this.likes.filter((like) => {
              return like.user_id !== this.CURRENTUSER.id;
            });
          }
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    moreAction() {
      const defaultActions = [
        {
          text: this.$t(this.has_collect ? "collect.cancel" : "collect.name"),
          method: () => {
            // POST /feeds/:feed/collections
            // DELETE /feeds/:feed/uncollect
            let url;
            let txt;
            let method;
            if (this.has_collect) {
              txt = this.$t("collect.name");
              method = "delete";
              url = `/feeds/${this.feedId}/uncollect`;
            } else {
              txt = this.$t("collect.already");
              method = "post";
              url = `/feeds/${this.feedId}/collections`;
            }

            this.$http({
              url,
              method,
              validateStatus: (s) => s === 204 || s === 201,
            }).then(() => {
              this.$Message.success(txt);
              this.has_collect = !this.has_collect;
            });
          },
        },
      ];

      const actions = this.isMine
        ? [
            {
              text: this.$t("feed.apply_top"),
              method: () => {
                this.$bus.$emit("applyTop", {
                  type: "feed",
                  api: api.applyTopFeed,
                  payload: this.feedId,
                });
              },
            },
            {
              text: this.$t("feed.delete"),
              method: () => {
                setTimeout(() => {
                  const actionSheet = [
                    {
                      text: this.$t("delete.name"),
                      style: { color: "#f4504d" },
                      method: () => {
                        api.deleteFeed(this.feedId).then(() => {
                          this.$Message.success(this.$t("feed.delete_success"));
                          this.goBack();
                        });
                      },
                    },
                  ];
                  this.$bus.$emit(
                    "actionSheet",
                    actionSheet,
                    this.$t("cancel"),
                    this.$t("delete.confirm")
                  );
                }, 200);
              },
            },
          ]
        : [
            {
              text: this.$t("report.name"),
              method: () => {
                this.$bus.$emit("report", {
                  type: "feed",
                  payload: this.feedId,
                  username: this.user.name,
                  reference: this.feed.feed_content,
                });
              },
            },
          ];
      this.$bus.$emit("actionSheet", [...defaultActions, ...actions]);
    },
    replyComment(comment) {
      const actions = [];
      // 是否是自己的评论
      if (comment.user_id === this.CURRENTUSER.id) {
        // 是否是自己文章的评论
        const isOwner = comment.user_id === this.user.id;
        actions.push({
          text: this.$t(isOwner ? "comment.top.name" : "comment.top.apply"),
          method: () => {
            this.$bus.$emit("applyTop", {
              isOwner,
              type: "feedComment",
              api: api.applyTopFeedComment,
              payload: {
                feedId: this.feedId,
                commentId: comment.id,
              },
              callback: this.fetchFeedComments,
            });
          },
        });
        actions.push({
          text: this.$t("comment.delete.name"),
          method: () => this.$refs.comments.delete(comment.id),
        });
      } else {
        actions.push({
          text: this.$t("reply.name"),
          method: () => this.$refs.comments.open(comment.user),
        });
        actions.push({
          text: this.$t("report.name"),
          method: () => {
            this.$bus.$emit("report", {
              type: "comment",
              payload: comment.id,
              username: comment.user.name,
              reference: comment.body,
            });
          },
        });
      }
      this.$bus.$emit("actionSheet", actions);
    },
    followUserByStatus(status) {
      if (!status || this.fetchFollow) return;
      this.fetchFollow = true;

      userApi
        .followUserByStatus({
          id: this.user.id,
          status,
        })
        .then((follower) => {
          this.relation = follower;
          this.fetchFollow = false;
        });
    },
    onRefresh() {
      this.$refs.loadmore.beforeRefresh();
      this.fetchFeed();
    },
    onFileClick(paidNode) {
      if (
        !paidNode ||
        paidNode.paid !== false ||
        paidNode.type === "download"
      ) {
        return;
      }

      if (this.$lstore.hasData("H5_ACCESS_TOKEN")) {
        this.$bus.$emit("payfor", {
          nodeType: this.$t("article.content"),
          node: paidNode.paid_node,
          amount: paidNode.amount,
          onSuccess: (data) => {
            this.$Message.success(data);
            this.feed.images = null;
            this.fetchFeed();
          },
        });
      } else {
        this.$nextTick(() => {
          const path = this.$route.fullPath;
          this.$router.push({
            path: "/signin",
            query: { redirect: path },
          });
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pic-8 {
  > div:first-child {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;

    > img {
      width: 342px;
      height: 342px;
    }
  }

  > div:last-child {
    display: flex;
    justify-content: space-between;
    flex-flow: wrap;

    > img {
      width: 226px;
      height: 226px;
      margin-bottom: 6px;
    }
  }
}

.pic-9 {
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;

  > .imgParet {
    width: 226px;
    height: 226px;
    margin-bottom: 6px;
    position: relative;
    > img {
      width: 100%;
      height: 100%;
    }
    > .imgCout {
      position: absolute;
      color: #fff;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 60px;
    }
  }
  > img {
    width: 226px;
    height: 226px;
    margin-bottom: 6px;
  }
}

.pic-7 {
  > div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;

    img {
      width: 342px;
      height: 342px;
    }
  }

  > div:last-child {
    display: flex;
    justify-content: space-between;

    > img {
      width: 226px;
      height: 226px;
    }
  }
}

.pic-5 {
  > div:first-child {
    display: flex;
    justify-content: space-between;

    img {
      display: block;
    }

    > img {
      width: 458px;
      height: 458px;
    }

    > div {
      height: 458px;
      display: flex;
      justify-content: space-between;
      flex-flow: column;

      > img {
        width: 226px;
        height: 226px;
      }
    }
  }

  > div:last-child {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;

    img {
      width: 342px;
      height: 342px;
    }
  }
}

.pic-6 {
  > div:last-child {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;

    img {
      width: 226px;
      height: 226px;
    }
  }
}

body {
  background: #fff;
}

.authorDetial,
.content,
.contaienr {
  padding: 0 0.2rem;
}

.feed-detail-video {
  height: auto;
  width: 100%;
  background: #000;
}

.flexBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.noCommentTip {
  text-align: center;
  margin: 0.5rem auto;
}

.fullScreenBar {
  border-bottom: 0.1rem solid #f5f5f5;
  margin-bottom: 0.4rem;
}

.topics {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 0 0;

  .topic-item {
    padding: 0 16px;
    border-radius: 6px;
    background-color: rgba(145, 209, 232, 0.12);
    font-size: 24px;
    color: @primary;
    margin-right: 12px;
    margin-bottom: 12px;
    cursor: pointer;
  }
}

.pic-2 {
  display: flex;
  justify-content: space-between;

  > div {
    width: 49.5%;

    img {
      display: block;
      height: 100%;
      margin: 0;
    }
  }
}

.pic-4 {
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;

  img {
    display: block;
    height: 342px;
    width: 342px;
    margin: 0 0 6px;
  }
}

.pic-3 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > div {
    overflow: hidden;
    height: 458px;
  }

  > div:first-child {
    img {
      width: 458px;
      height: 458px;
      display: block;
    }
  }

  > div:last-child {
    display: flex;
    flex-flow: column;
    justify-content: space-between;

    img {
      width: 226px;
      height: 226px;
      display: block;
    }
  }
}

.content {
  padding-bottom: 0.4rem;
}

.fullImg > img {
  width: 100%;
}

.auther-name {
  text-align: right;
  font-size: 0.24rem;
  color: #999999;
}

.imgParentView {
  border-radius: 15px;
  overflow: hidden;

  img {
    object-fit: cover;
  }
}

ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}

body {
  margin: 0;
  background-color: #fff;
}

.fullImg > img {
  width: 100%;
}

.authorDetial {
  justify-content: flex-start;
  padding: 0 0.31rem;
}

.authorImg {
  width: 0.68rem;
  margin-right: 0.15rem;
  height: 0.68rem;
  border-radius: 50%;
  overflow: hidden;
}

.authorImg img {
  border-radius: 50%;
}

.authorName {
  font-size: 0.28rem;
  color: #0d1824;
  line-height: 0.4rem;
}

.authorLabel {
  font-size: 0.22rem;
  line-height: 0.4rem;
  color: #989ca5;
}

.authorMsg > p,
.comment-content {
  text-align: justify;
}

.comment-content {
  margin-top: 0.24rem;
}

.comment-handel-icon {
  width: 0.3rem;
  margin-right: 0.1rem;
}

.comment-btn {
  margin-left: 0.3rem;
  color: #959aa9;
}

.comment-lists {
  padding-bottom: 0.3rem;
  border-bottom: 1px solid #eee;
  margin-bottom: 0.3rem;
}

.comment-lists .authorDetial {
  margin: 0;
}

.comment-reply {
  text-align: right;
  color: #959aa9;
}

.auther-name {
  /* margin: 0.24rem 0 0.64rem; */
  text-align: right;
  font-size: 0.24rem;
  color: #999999;
  font-weight: bold;
}

.shareTitle {
  text-align: center;
  font-size: 0.28rem;
  color: #333333;
  margin: 0.32rem auto 0.45rem;
  line-height: 1;
}

.newsLabel-info {
  display: inline-block;
  margin-left: 0.16rem;
}

.news-lookNumberIcon {
  display: inline-block;
  width: 0.28rem;
  height: 0.18rem;
  margin-right: 0.05rem;
}

.content-label {
  font-size: 0.24rem;
  color: #999999;
  text-align: right;
  margin: 0.24rem auto;
}

.sharePage {
  padding-bottom: 10vh;
}

.authorDetial {
  margin-top: 0.42rem;
}

.content .fullImg {
  margin: 0.24rem auto;
}

.comment-content {
  padding-left: 0.82rem;
}

.sharebarimg {
  display: block;
  margin-bottom: 0.2rem;
}

.sharebarimg > img {
  width: 100%;
  height: auto;
  display: block;
}

.fixedbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 200000;
  margin-bottom: 0;
}
</style>
